import { API_ENDPOINTS } from "./apiEndpoints";
import type {
  FindGroupJourneysParams,
  FindGroupJourneysResponse,
} from "../types/JourneyTypes";

export class JourneyApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "JourneyApiError";
    this.status = status;
  }
}

export async function findGroupJourneys(
  params: FindGroupJourneysParams
): Promise<FindGroupJourneysResponse> {
  const searchParams = new URLSearchParams(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const response = await fetch(
    `${API_ENDPOINTS.findGroupJourneys}?${searchParams.toString()}`
  );

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new JourneyApiError(
      data?.ErrorText || `Kunde inte hämta resor.`,
      response.status
    );
  }

  if (!data) {
    throw new JourneyApiError(
      "API:t returnerade ingen reseinformation.",
      response.status
    );
  }

  return {
    ...data,
    Journeys: Array.isArray(data.Journeys) ? data.Journeys : [],
  };
}
